import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("tq_token") || "";
export const setToken = (t) => t ? localStorage.setItem("tq_token", t) : localStorage.removeItem("tq_token");
export const getCartId = () => {
  let id = localStorage.getItem("tq_cart_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("tq_cart_id", id);
  }
  return id;
};

const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Cart-Id"] = getCartId();
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg = err.response?.data?.detail;
    err.friendlyMessage = typeof msg === "string" ? msg : (err.message === "Network Error" ? "Network error. Please check your connection." : "Something went wrong. Please try again.");
    return Promise.reject(err);
  }
);

export default api;
